import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const UpgradePaymentRedirectStep = ({ redirectCounter, onLoginNow }) => {
  return (
    <div className="upgrade-page-redirect">
      <p>{localeText("upgradedSuccessfullyText")}</p>
      <Button label={localeText("login")} className="p-button mt-2 mb-4" onClick={onLoginNow} />
      <p className="upgrade-page-redirect-counter">
        {localeText("youWillBeRedirectedIn")} {redirectCounter} {localeText("seconds")}
      </p>
    </div>
  );
};

export default UpgradePaymentRedirectStep;
